<button (click)="toggle()"
        [class.expanded]="expanded">
  <i class="material-icons">keyboard_arrow_down</i>
</button>
